import { render, staticRenderFns } from "./bigScreenAd.vue?vue&type=template&id=47e32ea2&scoped=true"
import script from "./bigScreenAd.vue?vue&type=script&lang=js"
export * from "./bigScreenAd.vue?vue&type=script&lang=js"
import style0 from "./bigScreenAd.vue?vue&type=style&index=0&id=47e32ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e32ea2",
  null
  
)

export default component.exports